define('collections/product_reseller_prices',['require','collections/base','models/product_reseller_price'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/product_reseller_price");

    return BaseCollection.extend({
        model: Model,
        url: 'product-prices.json',

        initialize: function (models, options) {
            this.url = App.Config.apiBase + this.url;

            if (options && options.parameters) {
                this.parameters = options.parameters;
            }
            this.set(models);
        }
    });
});

